import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError, retry, tap} from 'rxjs/operators';
import {PestsDiseaseWeed} from '../models/pests-disease-weed';
import {AppSettings} from '../../app.settings';
import {environment} from '../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'text/html',
    'Access-Control-Allow-Origin': '*'
  })
};
@Injectable({
  providedIn: 'root'
})
export class PestDiseaseWeedService {

  constructor(private http: HttpClient) { }

  // Fetch all pests, diseases and weeds
  getAll(page = '1', perPage = '20', orderColumn = 'id', orderDirection = 'desc'){
    const params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage)
      .set('order_column', orderColumn)
      .set('order_direction', orderDirection)
    ;
    const url = `${environment.baseUrl}pdw/`;
    return this.http.get<any>(url, {params})
      .pipe(
        retry(3), // retry a failed request up to 3 times
        catchError(this.handleError)
    );
  }

  // Fetch pest, disease or weed item based on id
  findById(id: string){
    const url = `${environment.baseUrl}pdw/${id}`;
    return this.http.get<any>(url)
      .pipe(
        retry(3), // retry a failed request up to 3 times
        catchError(this.handleError)
    );
  }

  // Find pests, diseases or weeds based on type
  findByType(type: string, page = '1', perPage = '20', orderColumn = 'id', orderDirection = 'desc',  searchValue = '') {
    const params = new HttpParams()
      .set('type', type)
      .set('page', page)
      .set('per_page', perPage)
      .set('order_column', orderColumn)
      .set('order_direction', orderDirection)
    ;
    const url = `${environment.baseUrl}pdw/filter/${searchValue}`;
    return this.http.get<any>(url, {params})
      .pipe(
        retry(3), // retry a failed request up to 3 times
        catchError(this.handleError)
      );
  }

  // Find pests, diseases or weeds names on type
  getNamesByType(type: string, page = '1', perPage = '20', orderColumn = 'id', orderDirection = 'desc',  searchValue = '') {
    const params = new HttpParams()
      .set('type', type)
      .set('page', page)
      .set('per_page', perPage)
      .set('order_column', orderColumn)
      .set('order_direction', orderDirection)
    ;
    const url = `${environment.baseUrl}pdw/summary/names/${searchValue}`;
    return this.http.get<any>(url, {params})
      .pipe(
        retry(3), // retry a failed request up to 3 times
        catchError(this.handleError)
      );
  }

  // Find pest, disease or weed's agrochem products based on toxicity (true|false)
  getAgrochemsByToxicity(id: string, toxic: string){
    const  params = new  HttpParams()
      .set('toxic', toxic)
    ;
    const url = `${environment.baseUrl}pdw/${id}/agrochems`;
    return this.http.get<any>(url, {params})
      .pipe(
        retry(3), // retry a failed request up to 3 times
        catchError(this.handleError)
    );
  }

  // Find pest, disease or weed's control methods
  findControlMethods(id: string){
    const url = `${environment.baseUrl}pdw/${id}/control_methods`;
    return this.http.get<any>(url)
      .pipe(
        retry(3), // retry a failed request up to 3 times
        catchError(this.handleError)
    );
  }

  // Error handling
  private handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error.message}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

}
